type ISOString = string
type HourOffset = string

export type TimeWindowInterval = [ISOString, HourOffset, HourOffset] | null

export enum ETimeUnit {
  MONTH = 'MONTH',
  DAY = 'DAY',
  HOUR = 'HOUR',
  MINUTE = 'MINUTE',
  SECOND = 'SECOND',
}

export type ActualTimeWindowInterval = {
  timeUnit: ETimeUnit
  interval: TimeWindowInterval
  field: string
  isFirstIntervalRun: boolean
} | null
